export default "__VITE_ASSET__Byj$JIvO__"